// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2HYpQ","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1AUNo"};